import React from 'react';
import {ScrollView} from 'react-native';
import {storiesOf} from '@storybook/react-native';

import {
  Code,
  FlexView,
  Heading,
  Spacer,
  Spacing,
} from '/component/base/Storybook';
import Text from '/component/base/Text';

import {LoadingBox} from '../LoadingBox';

storiesOf('base', module).add('Loading Box', () => (
  <ScrollView>
    <FlexView>
      <Spacing size={20}>
        <Heading level={1}>Loading Box Component</Heading>
        <Spacer size={16} />
        <Text>
          The <Code>{'LoadingBox'}</Code> component is used to create
          pre-loading screens.{' '}
        </Text>
        <Spacer size={20} />
        <LoadingBox style={{width: 100, height: 20}} />
        <Spacer size={20} />
        <Text>
          To use this component, you must pass the height and width in the style
          param
        </Text>
        <Spacer size={10} />
        <Code>{'<LoadingBox'}</Code>
        <Code>{'  style={{width: 100, height: 20}}'}</Code>
        <Code>{'/>'}</Code>
      </Spacing>
    </FlexView>
  </ScrollView>
));
